import Crud from '../views/Daily/Crud'
import Entity from '../views/Daily/Add'

let routes = {
    path: '/dailies',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/dailies/add',
            name: 'NewDaily',
            component: Entity,
            meta: {
                pageTitle: 'Daily',
                breadcrumb: [
                    {
                        text: 'Daily',
                        active: false,
                        to: '/dailies',
                    },
                    {
                        text: 'Adicionar Daily',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/dailies/view/:id?',
            name: 'ViewDaily',
            component: Entity,
            meta: {
                pageTitle: 'Daily',
                breadcrumb: [
                    {
                        text: 'Daily',
                        active: false,
                        to: '/dailies',
                    },
                    {
                        text: 'Editar Daily',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/dailies',
            name: 'list-dailies',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Daily',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
